import { Button, CustomColorScheme, IButtonProps } from "components/Button";

interface IProps extends Pick<IButtonProps, "onClick" | "isActive"> {
  title: string;
}

const HourButton = ({ title, ...props }: IProps) => {
  return (
    <Button
      customColorScheme={CustomColorScheme.Blue}
      justifySelf="center"
      borderRadius={15}
      w="110px"
      h="55px"
      id={`hour-btn-${title}`}
      {...props}
    >
      {title}
    </Button>
  );
};

export { HourButton };
